module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00004.ec03ae77.jpg";